export  default {
    data:{},
    getsmstype(){
        let type='sms';
        if(this.data.initData){
            console.log(this.data.initData);
            switch (this.data.initdata.sms.plame_type){
                case '1':
                    type='sms';
                    break;
                case '2':
                    type='sms';
                    break;
                case '3':
                    type='email'
                    break;
                default :
                    type='sms';
                    break;
            }
        }
        return type;
    }
}